import React, { useState } from "react";

import { Button, Divider, Modal } from "semantic-ui-react";

import { copyToClipboard } from "react-lib/apps/HISV3/common/CommonInterface";

type ModInviteLinkProps = {
  link: string;
  open: boolean;
  onClose: () => void;
};

type Styles = Record<
  | "closeButton"
  | "container"
  | "copyButton"
  | "copyButtonCopied"
  | "linkContainer"
  | "linkText"
  | "subtitle"
  | "title",
  React.CSSProperties
>;

const styles: Styles = {
  closeButton: {
    backgroundColor: "#d1d5db",
    borderRadius: "8px",
    color: "#374151",
    marginTop: "1rem",
  },
  container: {
    alignItems: "flex-start",
    display: "flex",
    flexDirection: "column",
    minWidth: "500px",
    padding: "2rem",
    textAlign: "left",
  },
  copyButton: {
    backgroundColor: "#ec4899",
    border: "none",
    borderRadius: "8px",
    color: "white",
    cursor: "pointer",
    fontSize: "0.9rem",
    fontWeight: "500",
    padding: "10px 16px",
    whiteSpace: "nowrap",
  },
  copyButtonCopied: {
    backgroundColor: "#10b981",
    border: "none",
    borderRadius: "8px",
    color: "white",
    cursor: "pointer",
    fontSize: "0.9rem",
    fontWeight: "500",
    padding: "10px 16px",
    whiteSpace: "nowrap",
  },
  linkContainer: {
    alignItems: "center",
    backgroundColor: "#f3f4f6",
    border: "1px solid #d1d5db",
    borderRadius: "8px",
    display: "flex",
    gap: "12px",
    marginBottom: "2rem",
    marginTop: "1.5rem",
    padding: "12px 16px",
    width: "100%",
  },
  linkText: {
    backgroundColor: "transparent",
    color: "#374151",
    flex: 1,
    fontFamily: "monospace",
    fontSize: "0.9rem",
    wordBreak: "break-all",
  },
  subtitle: {
    color: "#6b7280",
    fontSize: "0.95rem",
    lineHeight: "1.6",
    marginBottom: "0",
  },
  title: {
    color: "#1f2937",
    fontSize: "1.4rem",
    fontWeight: "600",
    margin: "-0.5rem 0 0.25rem",
  },
};

const ModInviteLink = (props: ModInviteLinkProps) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCloseModal = (): void => {
    props.onClose();

    setIsCopied(false);
  };

  const handleCopyLink = async (): Promise<void> => {
    const success = await copyToClipboard(props.link);

    if (success) {
      setIsCopied(true);
      setTimeout(() => handleCloseModal(), 1000);
    }
  };

  return (
    <Modal open={props.open} size="small" closeOnDimmerClick onClose={handleCloseModal}>
      <div style={styles.container}>
        <h1 style={styles.title}>สร้างคำเชิญให้สมาชิกใหม่</h1>

        <Divider style={{ margin: "1rem 0", width: "100%" }} />

        <p style={styles.subtitle}>
          คุณสามารถคัดลอกลิงก์นี้ส่งให้กับสมาชิกคนนั้น เพื่อมอบสิทธิ์ให้แก่สมาชิก
        </p>

        <div style={styles.linkContainer}>
          <span style={styles.linkText}>{props.link}</span>
          <Button
            style={isCopied ? styles.copyButtonCopied : styles.copyButton}
            onClick={handleCopyLink}
          >
            {isCopied ? "คัดลอกแล้ว ✓" : "คัดลอก Link"}
          </Button>
        </div>

        <div style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
          <Button style={styles.closeButton} onClick={handleCloseModal}>
            ปิดหน้าต่าง
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ModInviteLink;
